import PropTypes from 'prop-types';
import { displayTitle, formatDisplayedColumns, formatFooterColumns, getValidClassName } from '@/utils/footerDynamicLinksUtils';
import styles from './FooterDynamicLinks.module.scss';

const FooterDynamicLinks = ({ linkColumn, field, title, className, isMobile = false }) => {
	const validClassName = getValidClassName(className, isMobile, styles);

	const columns = formatFooterColumns(linkColumn, field);
	const displayedColumns = formatDisplayedColumns(columns, isMobile, validClassName.columns);

	return columns.length > 0 ? (
		<div className={validClassName.container} data-rbf="footer-archives-links" data-test-id="footer-dynamic-links">
			{displayTitle(title, validClassName.title)}
			<div className={`row ${validClassName.columnLinks}`}>{displayedColumns}</div>
		</div>
	) : null;
};

FooterDynamicLinks.propTypes = {
	linkColumn: PropTypes.arrayOf(PropTypes.object).isRequired,
	field: PropTypes.string,
	title: PropTypes.string.isRequired,
	className: PropTypes.shape({
		title: PropTypes.string.isRequired,
		container: PropTypes.string.isRequired,
		columns: PropTypes.string,
	}),
	isMobile: PropTypes.bool,
};

export default FooterDynamicLinks;
